import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../../routes/RoutesURL';

const ReferralView: React.FC = () => {
    const navigate = useNavigate();

    const termsConditions = [
        {
            terms: 'You need to be an approved investor with us. An approved investor is one who has completed account opening, passed Know-Your-Customer (KYC) checks and Accredited Investor verification, and agreed to the Non-Disclosure Agreement. An approved investor need not have invested with us yet.',
        },
        {
            terms: 'Your friend must invest into either any of the Helicap Funds or any Project listed on the Helicap Securities Platform within 6 months from the date of sign-up.',
        },
        { terms: 'Your friends must input your unique referral code into their account within 14 days of sign-up.' },
        { terms: 'You must not hold yourself as a representative of Helicap.' },
        { terms: 'You must not hold out as financial advisors providing any financial or investment advice.' },
        {
            terms: (
                <p>
                    Please{' '}
                    <span
                        className="text-blue-400 cursor-pointer"
                        onClick={() => {
                            navigate(`${HEADERMENU_PATH.referralTAC}`);
                        }}
                    >
                        click here
                    </span>{' '}
                    for the full terms and conditions.
                </p>
            ),
        },
    ];
    return (
        <div className="w-full">
            <div className="referral_fifth_block w-full p-4 md:p-12">
                <p className="WorkSans font-bold not-italic text-sm text-[#142C53] uppercase">*Terms & Conditions</p>
                <ul className="list-disc list-outside font-[Lato] not-italic font-normal text-base p-4">
                    {termsConditions.map((item, index) => (
                        <li key={`terms${index}`} className="text-sm text-[#5C5C5C]">
                            {item.terms}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default ReferralView;
